import { render } from "./JoinSection.vue?vue&type=template&id=58cbfa10&scoped=true"
import script from "./JoinSection.vue?vue&type=script&lang=js"
export * from "./JoinSection.vue?vue&type=script&lang=js"

import "./JoinSection.vue?vue&type=style&index=0&id=58cbfa10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cbfa10"]])

export default __exports__